import * as React from 'react'
import { sbEditable } from '@storyblok/storyblok-editable'
import { Icon } from '../Icon'
import { Button } from '../Button'
import { Styled } from './styled'

export const DownloadsItem = ({ item }) => {
  let name = ''

  if (item.name) {
    name = item.name
  } else if (!item.name) {
    name = item.file.title
  } else {
    name = item.file.filename
  }

  return (
    <Styled.Item {...sbEditable(item)} key={item._uid}>
      <Styled.ItemLink href={item.file.filename} target="_blank">
        {item?.thumbnail?.filename ? (
          <Styled.ItemImage src={item.thumbnail.filename} alt={name} />
        ) : (
          <Styled.ItemPlaceholder>
            <Icon name={item.fileTypeIcon} />
          </Styled.ItemPlaceholder>
        )}
        <Styled.ItemBody>
          <Styled.ItemHeadline className="anchor-block-child">{name}</Styled.ItemHeadline>
          <Styled.ItemMeta>
            {item.operationSystem && <span>{item.operationSystem}</span>}
            {item.technology && <span>{item.technology}</span>}
            {item.language && <span>{item.language}</span>}
            {item.metaDescription && <span>{item.metaDescription}</span>}
          </Styled.ItemMeta>
        </Styled.ItemBody>
        <Button as="span" $size="small" $variant="tertiary" $ignoreTheme iconLeft="download" />
      </Styled.ItemLink>
    </Styled.Item>
  )
}
